import { render } from "./generateLicensedPdfOth.vue?vue&type=template&id=6f3c27f0&scoped=true"
import script from "./generateLicensedPdfOth.vue?vue&type=script&lang=js"
export * from "./generateLicensedPdfOth.vue?vue&type=script&lang=js"

import "./generateLicensedPdfOth.vue?vue&type=style&index=0&id=6f3c27f0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3c27f0"]])

export default __exports__